import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import StarBorder from '@mui/icons-material/StarBorder';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import { useState } from "react"
import Confirmation from './Confirmation';
import StarIcon from '@mui/icons-material/Star';

export default function ShowCategory(props) {

    const [display, setDisplay] = useState(false)
    const [confirmation, setConfirmation] = useState(false)

    const editProduct = product => {
        props.setInitialProduct(product)
    }

    const removeCategory = () => {
        props.deleteCategory(props.category[0])
    }

    return (
        <>
            <Confirmation
                action={removeCategory}
                open={confirmation}
                setOpen={setConfirmation}
                title={"Estas seguro que quieres eliminar esta categoria?"}
                description={""}
                actionMsg={"Eliminar"}
                rejectMsg={"Cancelar"}
            />
            {props.products.length <= 0 ?
                <ListItem>
                    <ListItemText
                        primary={props.category[1]}
                        secondary={"Categoria sin productos"}
                    />
                    <IconButton onClick={setConfirmation.bind(this, true)}>
                        <DeleteForeverIcon color='error' />
                    </IconButton>
                </ListItem>
                :
                <>
                    <ListItemButton onClick={setDisplay.bind(this, !display)}>
                        <ListItemText
                            primary={props.category[1]}
                            secondary={"Productos: " + props.products.length}
                        />

                        {props.products.length <= 0 ?

                            <DeleteForeverIcon /> :

                            display ? <ExpandLess /> : <ExpandMore />}

                    </ListItemButton>

                    <Collapse in={display} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>

                            {props.products.map(product => {
                                return (
                                    <ListItemButton
                                        sx={{ pl: 4 }}
                                        onClick={editProduct.bind(this, product)}
                                        key={product[0]}
                                    >
                                        {product[1].featured ? <StarIcon color='primary' /> : <StarBorder color='primary' />}

                                        <ListItemText primary={'| ' + product[1].name} />

                                        <EditOutlinedIcon />

                                    </ListItemButton>
                                )
                            })}
                        </List>
                    </Collapse>
                </>
            }
            <Divider />
        </>
    )
}